import { Component, OnInit } from '@angular/core';
import Auth from '@aws-amplify/auth';
import { Router } from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { UtilsService } from '../../service/utils.service';
import { ProgressSpinnerService } from '../../service/progress-spinner.service';
import { ToastrService } from 'ngx-toastr';
import { LoginEvent } from '../../model/LoginEvent';
import { ServerConfig } from '../../model/ServerConfig';
import { EnvironmentType } from '../../model/EnvironmentType';
import { initApplicationSelector } from '../../store/Application/ApplicationSelector';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../store/Application/ApplicationReducer';
import { DarkModeService } from '../../service/dark-mode.service';

@Component({
  selector: 'ch-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  userNameFocus: boolean;
  form: UntypedFormGroup;
  forgotPasswordForm: UntypedFormGroup;

  isLoginInProgress: boolean;

  event: string = LoginEvent.LOGIN;

  loginEvent = LoginEvent;

  config: ServerConfig;
  EnvironmentType = EnvironmentType;

  turnOnDarkModeAfterLogin: boolean;

  constructor(
    private readonly router: Router,
    public readonly darkModeService: DarkModeService,
    private readonly applicationStore: Store<ApplicationState>,
    public readonly toastrService: ToastrService,
    public readonly progressSpinnerService: ProgressSpinnerService,
    private readonly fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.turnOnDarkModeAfterLogin = this.darkModeService.turnOffDarkModeIfOn();

    this.applicationStore
      .select(initApplicationSelector)
      .subscribe((config) => {
        this.config = config;
      });
    this.progressSpinnerService.decrease();
    this.form = this.fb.group(
      {
        username: new UntypedFormControl('user', [Validators.required]),
        code: new UntypedFormControl({ value: '', disabled: true }, [
          Validators.required,
        ]),
        password: new UntypedFormControl('ASDqwe123!', [
          Validators.required,
          Validators.maxLength(200),
        ]),
        newPassword: new UntypedFormControl({ value: '', disabled: true }, [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(200),
        ]),
        newPasswordAgain: new UntypedFormControl(
          { value: '', disabled: true },
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(200),
          ],
        ),
      },
      { validators: [UtilsService.passwordsMatched()] },
    );
  }

  changeToForgotPassword() {
    this.event = LoginEvent.FORGOT_PASSWORD;
  }

  backToLogin() {
    this.event = LoginEvent.LOGIN;
    this.form.reset();
  }

  forgetPassword() {
    if (this.form.get('username').invalid) {
      return;
    }

    Auth.forgotPassword(this.form.get('username').value)
      .then((data) => {
        this.event = LoginEvent.FORGOT_PASSWORD_SUBMIT;
        this.form.get('password').disable();
        this.form.get('code').enable();
        this.form.get('newPassword').enable();
        this.form.get('newPasswordAgain').enable();
      })
      .catch((err) => console.log(err));
  }

  forgetPasswordSubmit() {
    const username = this.form.get('username').value;
    const code = this.form.get('code').value;
    const password = this.form.get('newPassword').value;
    Auth.forgotPasswordSubmit(username, code, password)
      .then((data) => {
        this.form.get('password').enable();
        this.form.get('code').disable();
        this.form.get('newPassword').disable();
        this.form.get('newPasswordAgain').disable();
        this.event = LoginEvent.LOGIN;
        this.toastrService.success('Password successfully changed');
        this.form.reset();
      })
      .catch((err) => console.log(err));
  }

  async completeNewPassword(user): Promise<any> {
    return new Promise((resolve, reject) => {
      Auth.completeNewPassword(user, this.form.get('newPassword').value)
        .then((resp) => {
          this.event = LoginEvent.LOGIN;
          resolve(resp);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }

  successLogin() {
    this.router.navigateByUrl('').then(() => {
      if (this.turnOnDarkModeAfterLogin) {
        this.darkModeService.updateDarkMode();
      }
    });
  }
}
